import { useState } from 'react';
import { HiOutlineTrash } from 'react-icons/hi2';
import { Table, reviewsColumns } from '../../../commons/Table';
import { useReviews } from '../../../../hooks';
import { Alert, Modal } from '../../../commons';
import { ReviewProps } from '../../../../constants';
import { DAV_APIS } from '../../../../adapters';
import { Card } from '../../../ui/Card';

const Reviews = () => {
  const [selected, setSelected] = useState({} as ReviewProps);
  const [refresh, setRefresh] = useState<number | null>(null);
  const [showModal, setShowModal] = useState(false);
  const [isLoading, setIsLoading] = useState(false);

  const onDeleteHandler = (e: any, review: ReviewProps) => {
    e.stopPropagation();
    setSelected(review);
    setShowModal(true);
  };

  const handleDeleteReview = async () => {
    setIsLoading(true);
    try {
      const res = await DAV_APIS.tour.deleteReviewById(selected.id as string);
      if (res.status === 204) {
        Alert({ message: 'Deleted Successfully', variant: 'success' });
      }
      setIsLoading(false);
      setShowModal(false);
      setRefresh(Math.random());
    } catch (error) {
      setIsLoading(false);
      setShowModal(false);
      Alert({ message: 'Failed to delete review', variant: 'error' });
    }
  };

  const { reviews, loading } = useReviews(refresh);

  return (
    <div className='space-y-6 animate-in fade-in slide-in-from-bottom-4 duration-700'>
      {/* Page Header */}
      <div className='flex flex-col md:flex-row md:items-center justify-between gap-4'>
        <div>
          <h1 className='text-2xl font-bold text-gray-900 dark:text-white'>
            Client Reviews
          </h1>
          <p className='text-gray-500 dark:text-gray-400 mt-1 text-sm md:text-base'>
            Monitor and manage feedback from safari enthusiasts.
          </p>
        </div>

      </div>

      {/* Main Content Card */}
      <Card variant='glass' className='overflow-hidden border-none shadow-xl shadow-gray-200/50 dark:shadow-none'>
        {/* @ts-ignore */}
        <Table
          columns={reviewsColumns}
          data={reviews}
          loading={loading}
          onDeleteHandler={onDeleteHandler}
          recordName='Reviews'
          placeholder='Search by reviewer name or email...'
        />
      </Card>

      {/* Delete Confirmation Modal */}
      <Modal
        size='sm'
        open={showModal}
        onClose={() => setShowModal(false)}
        onSuccess={handleDeleteReview}
        loading={isLoading}
        successText='Delete Review'
        loadingText='Deleting...'
      >
        <div className='space-y-3'>
          <div className='w-12 h-12 bg-red-50 dark:bg-red-900/20 rounded-full flex items-center justify-center text-red-600 mb-4'>
            <HiOutlineTrash className='w-6 h-6' />
          </div>
          <h2 className='text-xl font-bold text-gray-900 dark:text-white'>Remove Review</h2>
          <p className='text-gray-600 dark:text-gray-400 leading-relaxed'>
            Are you sure you want to delete the review by <span className='font-bold text-gray-900 dark:text-white'>{selected?.user_name || selected?.email}</span>? This action is permanent.
          </p>
        </div>
      </Modal>
    </div>
  );
};

export default Reviews;
